module.exports = __webpack_public_path__ + "static/media/image-placeholder.3bf6d1b2.svg";